/* eslint-disable import/prefer-default-export */
import ApiService from '../services/apiService';

const util = require('util');

const env = process.env.NODE_ENV;

const SKIPPED_ERRORS = [
  // Add more error message substrings to skip
  'Access Denied',
];

const shouldSkipError = (error) => {
  const message = util.inspect(error, { depth: null });
  return SKIPPED_ERRORS.some((msg) => message.includes(msg));
};

export const logError = (error = {}, description) => {
  if (env === 'test' || env === 'development') {
    console.log(util.inspect(error, { depth: null }));
  } else {
    // Check if the error message should be skipped
    if (shouldSkipError(error)) {
      return;
    }

    const errorMessage = error?.message;
    const errorStack = error?.stack || '';

    ApiService.logError({
      data: {
        errorMessage,
        errorStack,
      },
      description,
    }, env)
      .catch((err) => {
        // e.g. user has no internet or Backend doesn't provide the API
        console.log('Exception logging error: ', err);
      });
  }
};
